module.exports = __webpack_public_path__ + "static/media/gannon-office-solutions.797aff2d.png";